// controllers/clienteController.ts

import { api } from '@services/api';
import {
  Cliente,
  ClienteRequest,
  ClienteDadosRequest,
  CadClienteRequest,
  ClienteResponse,
  MENSAGENS
} from '@types';

class ClienteController {
  /**
   * Obtém a lista de clientes do vendedor
   */
  async obterClientes(vendedor: string): Promise<Cliente[]> {
    try {
      const request: ClienteRequest = { vendedor };
      const data = await api.post<Cliente[]>('/obterCliente/', request);
      console.log('ClienteController - Data recebido:');
      console.log(data);
      console.log('ClienteController - Tipo:', typeof data, Array.isArray(data));
      return data;
    } catch (error) {
      console.error('Erro ao obter clientes:', error);
      throw error;
    }
  }

  /**
   * Obtém a lista de clientes do vendedor com busca por texto na API
   */
  async obterClientesPorBusca(vendedor: string, procurar: string): Promise<Cliente[]> {
    try {
      const request = { vendedor, procurar };
      const data = await api.post<Cliente[]>('/obterCliente/', request);
      console.log('ClienteController - Busca API - Data recebido:', data);
      return data;
    } catch (error) {
      console.error('Erro ao buscar clientes:', error);
      throw error;
    }
  }

  /**
   * Obtém os dados detalhados de um cliente específico
   */
  async obterClienteDados(codigo: string, vendedor: string): Promise<Cliente> {
    try {
      const request: ClienteDadosRequest = { codigo, vendedor };
      console.log('ClienteController - obterClienteDados - Request:', request);
      const data = await api.post<Cliente>('/obterClienteDados/', request);
      console.log('ClienteController - obterClienteDados - Response:', data);
      console.log('ClienteController - obterClienteDados - Tipo:', typeof data);
      return data;
    } catch (error) {
      console.error('ClienteController - obterClienteDados - Erro:', error);
      throw error;
    }
  }

  /**
   * Cadastra um novo cliente
   */
  async cadastrarCliente(dados: CadClienteRequest): Promise<ClienteResponse> {
    try {
      const response = await api.post<ClienteResponse>('/cadCliente/', dados);
      return response;
    } catch (error) {
      console.error('Erro ao cadastrar cliente:', error);
      throw error;
    }
  }

  /**
   * Filtra clientes por texto de busca
   */
  filtrarClientes(clientes: Cliente[], busca: string): Cliente[] {
    if (!busca.trim()) return clientes;

    const termoBusca = busca.toLowerCase().trim();
    
    return clientes.filter(cliente =>
      String(cliente.codigo).toLowerCase().includes(termoBusca) ||
      String(cliente.nome).toLowerCase().includes(termoBusca) ||
      String(cliente.razao).toLowerCase().includes(termoBusca) ||
      String(cliente.endereco).toLowerCase().includes(termoBusca) ||
      String(cliente.cidade).toLowerCase().includes(termoBusca) ||
      String(cliente.bairro).toLowerCase().includes(termoBusca)
    );
  }

  /**
   * Verifica se o cliente está ativo para pedidos
   */
  clienteAtivo(cliente: Cliente): boolean {
    return cliente.financas === 0;
  }

  /**
   * Obtém mensagem de status do cliente
   */
  obterStatusCliente(cliente: Cliente): { ativo: boolean; mensagem: string } {
    const ativo = this.clienteAtivo(cliente);
    return {
      ativo,
      mensagem: ativo ? MENSAGENS.CLIENTE_ATIVO : MENSAGENS.CLIENTE_SEM_CREDITO
    };
  }

  /**
   * Valida CNPJ
   */
  validarCNPJ(cnpj: string): boolean {
    // Remove caracteres não numéricos
    const cnpjLimpo = cnpj.replace(/[^\d]/g, '');

    // Verifica se tem 14 dígitos
    if (cnpjLimpo.length !== 14) return false;

    // Verifica se todos os dígitos são iguais
    if (/^(\d)\1+$/.test(cnpjLimpo)) return false;

    // Validação do primeiro dígito verificador
    let tamanho = cnpjLimpo.length - 2;
    let numeros = cnpjLimpo.substring(0, tamanho);
    const digitos = cnpjLimpo.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    // Validação do segundo dígito verificador
    tamanho = tamanho + 1;
    numeros = cnpjLimpo.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(1))) return false;

    return true;
  }

  /**
   * Formata CNPJ para exibição
   */
  formatarCNPJ(cnpj: string): string {
    const cnpjLimpo = cnpj.replace(/[^\d]/g, '');
    
    if (cnpjLimpo.length !== 14) return cnpj;

    return cnpjLimpo.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
    );
  }
}

export default new ClienteController();
